<template>
  <div class="height-100-p">
    <el-form :model="editForm" ref="editForm">
    <el-table
      :data="coolerInventory.list"
      v-loading="coolerInventory.loadingSearch"
      id="coolerInventory-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
       @sort-change="handleSortChange"
       :default-sort = "{prop: 'shipperAccountName', order: 'ascending'}"
      stripe>
      <el-table-column
        prop="coolerStatus"
        :label="$t('coolerInventory.status')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
         <span>{{ coolerInventoryStatusLabel(scope.row.coolerStatus)}}</span>
        </template>
          <template slot-scope="scope">
              <template v-if="!scope.row.edit">
                  <el-tooltip class="item" effect="dark" :content="coolerInventoryStatusLabel(scope.row.coolerStatus)" placement="top">
                      <span>{{ coolerInventoryStatusLabel(scope.row.coolerStatus)}}</span>
                  </el-tooltip>
              </template>
              <template v-else>
                  <el-select
                          v-model="editForm.status"
                          id="edit-status-select"
                          ref="status-select">
                      <el-option
                              v-for="item in getStatusToSelect()"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                      </el-option>
                  </el-select>
              </template>
          </template>
      </el-table-column>
     <el-table-column
        prop="shipperAccountName"
        :label="$t('coolerInventory.shipper')"
        :min-width="8"
        align="left"
        header-align="center"
        sortable="custom">
        <template slot-scope="scope">
           <el-tooltip class="item" effect="dark" :content="`${ scope.row.shipperAccountName }`" placement="top">
            <span>{{ scope.row.shipperAccountName }}</span>
            </el-tooltip>
        </template>
      </el-table-column>
       <el-table-column
        prop="consigneeAccountName"
        :label="$t('coolerInventory.consignee')"
        :min-width="8"
        align="left"
        header-align="center"
        sortable="custom">
         <template slot-scope="scope">
           <el-tooltip class="item" effect="dark" :content="`${ scope.row.consigneeAccountName }`" placement="top">
             <span>{{ scope.row.consigneeAccountName }}</span>
            </el-tooltip>
        </template>
      </el-table-column>
       <el-table-column
        prop="dimensions"
        :label="$t('coolerInventory.dimensions')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
         <span>{{scope.row.dimensions}}</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="numberUnits"
        :label="$t('coolerInventory.numberUnits')"
        :min-width="3"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
         <span>{{scope.row.numberUnits}}</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="receivingWarehouseCode"
        :label="$t('coolerInventory.receivingWarehouse')"
        :min-width="4"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
         <span>{{scope.row.receivingWarehouseCode}}</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="dayOfService"
        :label="$t('coolerInventory.dos')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
            <span> {{ scope.row.dayOfService | moment(dateDisplayFormat) }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="faultDescription"
        :label="$t('coolerInventory.fault')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <el-tooltip class="item" effect="dark" :content="scope.row.faultDescription" placement="top">
              <span> {{ scope.row.faultDescription }} </span>
            </el-tooltip>
          </template>
          <template v-else>
            <select-list id="edit-fault-select" :value.sync="editForm.faultId" :url="urlFaults" label-field="description" value-field="id" ref="fault-select" />
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="dispositionDescription"
        :label="$t('coolerInventory.disposition')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <el-tooltip class="item" effect="dark" :content="scope.row.dispositionDescription" placement="top">
              <span> {{ scope.row.dispositionDescription }} </span>
            </el-tooltip>
          </template>
          <template v-else>
            <select-list id="edit-disposition-select" :value.sync="editForm.dispositionId"  :url="urlDispositions" label-field="description" value-field="id" ref="disposition-select" />
          </template>
        </template>
       </el-table-column>
       <el-table-column
        prop="notes"
        :label="$t('coolerInventory.notes')"
        :min-width="8"
        sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <el-tooltip class="item" effect="dark" :content="scope.row.notes" placement="top">
              <span> {{ scope.row.notes }} </span>
            </el-tooltip>
          </template>
          <template v-else>
         <el-form-item prop="number">
            <el-input
            v-model="editForm.notes"
            maxlength="200"
            class="inline-input"
            id="cooler-inventory-form-notes"
            ref="cooler-inventory-form-notes"
            ></el-input>
          </el-form-item>
          </template>
        </template>
      </el-table-column>
        <el-table-column
        prop="reShip"
        :label="$t('coolerInventory.reShip')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
         <span>{{scope.row.reShip | moment(dateDisplayFormat)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="options" :label="$t('common.options')" :min-width="4" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="showEditButton()" class="item" effect="dark" :enterable="false" :content="$t('coolerInventory.edit')" placement="top-start">
            <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
          </el-tooltip>
          <template v-else-if="scope.row.edit">
            <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate(scope.row)"></el-button>
            <el-button icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)"></el-button>
          </template>
          <change-ship-date-dialog :cooler-inventory-object="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    </el-form>
    <div class="pagination-footer" v-show="coolerInventory.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('coolerInventory.totalCoolers') }}</span>
           {{ coolerInventory.total }}
      </span>
      <el-pagination
      @size-change="handleSearchChangeLimit"
      :page-sizes="sizes"
      :page-size="coolerInventory.actualFilters.rows"
      :current-page.sync="coolerInventory.actualFilters.page"
      @current-change="handleSearchChangePage"
      :total="coolerInventory.total"
      layout="slot, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import transformLabels from '@/plugins/unitDataTransformLabels';
import SelectList from '@/components/Select/SelectList';
import apiConstants from '@/utils/apiConstants';
import ChangeShipDateDialog from './components/ChangeShipDateDialog';

export default {
  name: 'SearchSummary',
  mixins: [transformLabels],
  components: {
    SelectList,
    ChangeShipDateDialog
  },
  computed: {
    ...mapGetters(['coolerInventory']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    }
  },
  data() {
    return {
      editForm: {
        status: null,
        coolerId: null,
        faultId: null,
        dispositionId: null,
        notes: ''
      },
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      coolerInventoryStatusOptions: constants.COOLER_INVENTORY.STATUS,
      urlFaults: apiConstants.END_POINTS.COOLER_INVENTORY.FAULTS,
      urlDispositions: apiConstants.END_POINTS.COOLER_INVENTORY.DISPOSITIONS
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch('coolerInventory/search', { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch('coolerInventory/search', { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch('coolerInventory/search', { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    },
    showEditButton() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_COOLER_INVENTORY) && !this.coolerInventory.isEditingRow;
    },
    handleEdit(row) {
      this.$store.dispatch('coolerInventory/setEditingRow', true);
      row.edit = true;
      this.editForm.status = row.coolerStatus;
      this.editForm.coolerId = row.coolerId;
      this.editForm.faultId = row.faultId;
      this.editForm.dispositionId = row.dispositionId;
      this.editForm.notes = row.notes;
    },
    handleUpdate() {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('coolerInventory/update', {
        coolerId: this.editForm.coolerId,
        coolerToUpdate: this.editForm
      }).then((response) => {
        loading.close();
        this.$message.success(response.message);
        this.clearEdit();
        this.$store.dispatch('coolerInventory/search', {});
      }).catch(() => {
        loading.close();
      });
    },
    clearEdit() {
      this.$store.dispatch('coolerInventory/setEditingRow', false);
      this.$refs.editForm.resetFields();
    },
    cancelEdit(row) {
      row.edit = false;
      this.clearEdit();
    },
    getStatusToSelect() {
      return this.coolerInventoryStatusOptions.slice(1);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
 #coolerInventory-data-list {
    #edit-fault-select,
    #edit-disposition-select,
    #edit-status-select {
        line-height: 1.15;
    }
}
</style>
